var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100 confirmation-page auto" }, [
    _c("div", { staticClass: "row mx-0" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 mb-3 text-center text-white product-section-heading",
              class: { error: _vm.isBindError }
            },
            [
              _c("div", { staticClass: "row no-gutters" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-10 pr-2 text-left" }, [
                  _c("h1", { staticClass: "title-banner m-0" }, [
                    _vm._v(_vm._s(_vm.pageTitle))
                  ])
                ])
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _vm.isBindError
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 carrier-logo-property text-center my-3 min-height align-items-center justify-content-center d-flex"
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.logoPathSvg,
                      alt: "logo",
                      width: "180.763px",
                      height: "auto"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 p-0" }, [
                _c("div", { staticClass: "shadow-sm rounded" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "py-2 pl-3 mb-2 text-white  product-section-heading rounded-top",
                      attrs: { role: "heading", "aria-level": "3" }
                    },
                    [_vm._v("\n              Next steps\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row mx-0 pt-8 px-3 pb-3 next-step-row" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.pageData.Error.Message) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.dataTree, function(group, i) {
            return group && !_vm.isBindError
              ? _c(
                  "div",
                  { key: i, staticClass: "my-3" },
                  [
                    _c("form-sections", {
                      attrs: { group: group, i: i, pageData: _vm.pageData }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _vm.footerNote() ? _c("hr") : _vm._e(),
    _vm._v(" "),
    _vm.footerNote()
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center mx-auto mt-3" },
          [
            _c(
              "div",
              {
                staticClass: "alert alert-primary my-0 py-2 w-50",
                attrs: { role: "note" }
              },
              [
                _c("div", { staticClass: "row no-gutters" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col d-inline-block my-auto smaller-font-content"
                    },
                    [_vm._v(_vm._s(_vm.footerNote()))]
                  )
                ])
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 policy-type" }, [
      _c("span", { staticClass: "fas fa-car" }),
      _vm._v(" Auto\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2530f670", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2530f670","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/shared/AutoConfirmation.vue
// module id = null
// module chunks = 